import { render, staticRenderFns } from "./lista-de-cuentas.vue?vue&type=template&id=3cb9e38e&"
import script from "./lista-de-cuentas.vue?vue&type=script&lang=ts&"
export * from "./lista-de-cuentas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports